import { pageDefault } from '../common.js'
import {
  CONTACT_CREATE_ACTION,
  CONTACT_SHOW_ADD_DIALOG_ACTION,
  CONTACT_HIDE_ADD_DIALOG_ACTION,
  CONTACT_GET_OK_ACTION,
  CONTACT_UPDATE_ACTION,
  CONTACT_SHOW_EDIT_DIALOG_ACTION,
  CONTACT_HIDE_EDIT_DIALOG_ACTION,
  CONTACT_DELETE_ACTION,
  CONTACT_SHOW_DELETE_DIALOG_ACTION,
  CONTACT_HIDE_DELETE_DIALOG_ACTION,

  CONTACT_GET_PAGE_ITEMS_ACTION,
  CONTACT_SET_ORDER_ACTION,
  CONTACT_SET_LIMIT_ACTION,
  CONTACT_SET_OFFSET_ACTION,
  CONTACT_SET_SEARCH_ACTION,
  CONTACT_RESET_SEARCH_ACTION,
  CONTACT_SET_FILTER_QUERIES_ACTION,

  CONTACT_SET_SELECTED_ITEM_ID
} from './actions.js'

const initialState = pageDefault('name', 'contact')

/**
 * Reducer for handling contacts.
 */
export function contact (state = initialState, action) {
  switch (action.type) {
    case CONTACT_GET_OK_ACTION:
      return {
        ...state,
        items: action.items.slice(),
        isSearching: false
      }
    case CONTACT_CREATE_ACTION:
      return {
        ...state,
        items: state.items.concat(action.contact),
        pageItems: [action.contact].concat(state.pageItems)
      }
    case CONTACT_SHOW_ADD_DIALOG_ACTION:
      return { ...state, addItem: true }
    case CONTACT_HIDE_ADD_DIALOG_ACTION:
      return { ...state, addItem: false }
    case CONTACT_UPDATE_ACTION:
      return {
        ...state,
        items: state.items.map(c => {
          return c.id === action.contact.id ? action.contact : c
        })
      }
    case CONTACT_SHOW_EDIT_DIALOG_ACTION:
      return { ...state, editItem: action.contact }
    case CONTACT_HIDE_EDIT_DIALOG_ACTION:
      return { ...state, editItem: null }
    case CONTACT_DELETE_ACTION:
      return {
        ...state,
        items: state.items.filter(c => c.id !== action.contact.id)
      }
    case CONTACT_SHOW_DELETE_DIALOG_ACTION:
      return { ...state, deleteItem: action.contact }
    case CONTACT_HIDE_DELETE_DIALOG_ACTION:
      return { ...state, deleteItem: null }

    case CONTACT_GET_PAGE_ITEMS_ACTION:
      return { ...state, pageItems: action.pageItems, isSearching: false }
    case CONTACT_SET_ORDER_ACTION: {
      const { order, orderBy } = action
      return { ...state, order, orderBy, offset: 0 }
    }
    case CONTACT_SET_LIMIT_ACTION:
      return { ...state, limit: action.limit, offset: 0 }
    case CONTACT_SET_OFFSET_ACTION:
      return { ...state, offset: action.offset }
    case CONTACT_SET_SEARCH_ACTION:
      return { ...state, search: action.search, isSearching: true, offset: 0 }
    case CONTACT_RESET_SEARCH_ACTION:
      return { ...state, search: '', isSearching: false, offset: 0 }
    case CONTACT_SET_FILTER_QUERIES_ACTION:
      return { ...state, filterQueries: action.filterQueries, offset: 0 }
    case CONTACT_SET_SELECTED_ITEM_ID:
      return { ...state, selectedItemId: action.selectedItemId }

    default:
      return state
  }
}
